import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import {
  TuiIslandDirective,
  TuiTextfieldControllerModule,
  TuiTextareaModule,
  TuiInputModule,
  TuiInputDateModule,
  TuiInputNumberModule,
  TuiInputYearModule,
  TuiMultiSelectModule,
  TuiSelectModule,
} from '@taiga-ui/legacy';
import { TuiDataListWrapper, TuiBlock, TuiCheckbox, TuiSkeleton } from '@taiga-ui/kit';
import { TuiDataList, TuiScrollbar, TuiScrollable, TuiGroup, TuiIcon, TuiButton } from '@taiga-ui/core';
import { TuiAutoFocus, TuiLet } from '@taiga-ui/cdk';
import { NgxPermissionsModule } from 'ngx-permissions';
import { FieldModule } from '@src/app/shared/field';
import { SharedModule } from '@src/app/shared';
import { PhotoModule } from '@src/app/modules/photo';
import { PhoneModule } from '@src/app/modules/phone';
import { WaitTelegramChatsModule } from '@src/app/modules/wait-telegram-chats';
import { ContactsModule } from '@src/app/modules/contacts';
import { ComponentsModule } from '@src/app/components';
import { ReportsModule } from '@src/app/modules/reports';
import { OrganisationInputModule } from '@src/app/modules/organisation-input';
import { CommitteeFieldModule } from '@src/app/modules/committees/committee-field';
import { DeleteAuthUserLinkModule } from '@src/app/modules/delete-auth-user-link';
import { NewListModule } from '@src/app/modules/list';
import { SearchCitiesModule } from '@src/app/modules/search-cities';
import { LoyaltyProgramModule } from '@src/app/modules/loyalty-program';
import { InputFilesModule } from '@src/app/modules/input-files';
import { SearchUsersModule } from '@src/app/modules/search-users';
import { CustomNamesTabsModule } from '@src/app/modules/custom-name-tabs';
import { JobTitleFieldModule } from '@src/app/modules/job-title-field';

import { UserInfoComponent } from './user-info.component';
import { UserInfoViewComponent } from './user-info-view/user-info-view.component';
import { UserInfoEditComponent } from './user-info-edit/user-info-edit.component';
import { UserInfoModerationComponent } from './user-info-moderation/user-info-moderation.component';

@NgModule({
  declarations: [UserInfoComponent, UserInfoViewComponent, UserInfoEditComponent, UserInfoModerationComponent],
  imports: [
    CommonModule,
    ComponentsModule,
    FieldModule,
    FormsModule,
    NgxPermissionsModule,
    PhoneModule,
    PhotoModule,
    ReactiveFormsModule,
    RouterModule,
    SearchUsersModule,
    SharedModule,
    TuiAutoFocus,
    TuiButton,
    ...TuiDataList,
    ...TuiDataListWrapper,
    TuiInputModule,
    TuiGroup,
    TuiInputDateModule,
    TuiInputNumberModule,
    TuiInputYearModule,
    TuiIslandDirective,
    TuiLet,
    TuiMultiSelectModule,
    TuiScrollbar,
    TuiScrollable,
    TuiSelectModule,
    TuiIcon,
    TuiTextareaModule,
    TuiTextfieldControllerModule,
    TuiBlock,
    TuiCheckbox,
    CustomNamesTabsModule,
    WaitTelegramChatsModule,
    ContactsModule,
    ReportsModule,
    OrganisationInputModule,
    CommitteeFieldModule,
    DeleteAuthUserLinkModule,
    NewListModule,
    SearchCitiesModule,
    LoyaltyProgramModule,
    InputFilesModule,
    TuiSkeleton,
    JobTitleFieldModule,
  ],
  exports: [UserInfoComponent, UserInfoModerationComponent],
})
export class UserInfoModule {}
